import { useCallback } from "react";

import { formatDate } from "../../utils/dateUtils";
import { useLocalization } from "../Localization";

export const useFormatDate = (dateFormat?: string) => {
  const localization = useLocalization();
  const format = dateFormat ? dateFormat : localization.dateFormat;
  return useCallback(
    (value, long) => {
      return formatDate(value, format, long);
    },
    [format]
  );
};
